import fetchApi from "../fetchApi";
import {DEFAULT_LIMIT} from "../../contstants";
export const GetUsers = async (limit = DEFAULT_LIMIT, offset = 0, status = '', role = '', email = '', first_name = '', last_name = '', office = '') => {

    const options = {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        redirect: 'follow'
    }

    return await fetchApi(`users?limit=${limit}&offset=${offset}&status=${status}&role=${role}&email=${email}&first_name=${first_name}&last_name=${last_name}&office_id=${office}`, options);
};